import React from 'react'
import LicenseCertificateCreate from '../../components/licensecertificatedetailscomponents/LicenseCertificateCreate';

function LicenseCertificateCreatePage({ renderPageContent }) {
    return (
        <>
            {/*Dynamic content goes here */}
            <LicenseCertificateCreate renderPageContent={renderPageContent} />


        </>
    )
}

export default LicenseCertificateCreatePage;